module.exports = __webpack_public_path__ + "assets/img/large_logo.e0c89f36.svg";